var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2IconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10V0H16L10.5763 5.11111L15.7535 10H0Z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.924V3H5.364V3.588H3.696V4.59H5.106V5.178H3.696V6.336H5.424V6.924H3Z",
    fill: "#1E1E2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95852 6.924V6.522C6.31452 6.178 6.62052 5.872 6.87652 5.604C7.13652 5.332 7.33652 5.086 7.47652 4.866C7.61652 4.642 7.68652 4.434 7.68652 4.242C7.68652 4.042 7.63252 3.882 7.52452 3.762C7.41652 3.642 7.26052 3.582 7.05652 3.582C6.90852 3.582 6.77252 3.624 6.64852 3.708C6.52852 3.792 6.41652 3.892 6.31252 4.008L5.92852 3.624C6.10452 3.436 6.28652 3.292 6.47452 3.192C6.66252 3.088 6.88652 3.036 7.14652 3.036C7.51452 3.036 7.80652 3.142 8.02252 3.354C8.24252 3.566 8.35252 3.85 8.35252 4.206C8.35252 4.43 8.28852 4.66 8.16052 4.896C8.03652 5.128 7.86852 5.366 7.65652 5.61C7.44852 5.854 7.21852 6.11 6.96652 6.378C7.06652 6.37 7.17452 6.362 7.29052 6.354C7.40652 6.342 7.51052 6.336 7.60252 6.336H8.53852V6.924H5.95852Z",
    fill: "#1E1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2IconMenu);
export default __webpack_public_path__ + "static/media/e2-icon-menu.389a7db977078c414a4f426982cec916.svg";
export { ForwardRef as ReactComponent };